var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconInfoSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.547 12c0 5.825-4.722 10.547-10.547 10.547S1.453 17.825 1.453 12 6.175 1.453 12 1.453 22.547 6.175 22.547 12M10.87 6.65a1.102 1.102 0 1 1 1.557 1.559A1.102 1.102 0 0 1 10.87 6.65m-1.026 3.944a.75.75 0 0 1 .75-.75h.703a1.453 1.453 0 0 1 1.453 1.453v3.515a.656.656 0 0 0 .656.657h.703a.75.75 0 1 1 0 1.5h-.703a2.156 2.156 0 0 1-2.156-2.157v-3.468h-.656a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.547 12c0 5.825-4.722 10.547-10.547 10.547S1.453 17.825 1.453 12 6.175 1.453 12 1.453 22.547 6.175 22.547 12M10.87 6.65a1.102 1.102 0 1 1 1.557 1.559A1.102 1.102 0 0 1 10.87 6.65m-1.026 3.944a.75.75 0 0 1 .75-.75h.703a1.453 1.453 0 0 1 1.453 1.453v3.515a.656.656 0 0 0 .656.657h.703a.75.75 0 1 1 0 1.5h-.703a2.156 2.156 0 0 1-2.156-2.157v-3.468h-.656a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
});
export default SvgIconInfoSolid;
export const raw = __webpack_public_path__ + "static/media/IconInfoSolid.a377b5c31574c653a4affa65bd094ec3.svg";